module.exports = __webpack_public_path__ + "static/media/Login.e3bdf7e4.png";